import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import Layout from "../../src/Layout";
import VideoFeed from "../../src/VideoFeed";
import CommentFeed from "../../src/CommentFeed";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Link from "../../src/Link";
import VideoPlayer from "../../src/VideoPlayer";
import withAuth from "../../src/utils/withAuth";
import Error from "next/error";
import { db, fv } from "../../src/utils/firebase";
import GameList from "../../src/GameList";
import TagList from "../../src/TagList";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Modal from "@material-ui/core/Modal";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import {
  followUser,
  unfollowUser,
  isFollowingUser,
  getAllRelatedPosts,
  getUser,
} from "../../src/utils/firebase";
import router from "next/router";

import LikeIcon from "@material-ui/icons/ThumbUp";

import CommentIcon from "@material-ui/icons/Chat";
import {
  FacebookShareIcon,
  TwitterShareIcon,
  EmailShareIcon,
} from "../../src/SocialShareIcons";

import moment from "moment";
import { linkify } from "../../src/utils/linkify";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 220,
  },
  modal: {
    padding: "0 0 40px 0",
    backgroundColor: "#fff",
    position: "relative",
    top: 60,
    display: "block",
    margin: "0 auto",
    height: "fit-content",
    width: "fit-content",
    maxHeight: "80vh",
    overflow: "scroll",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
    borderBottom: "solid 1px #E4E4E4",
    padding: "10px 36px 10px 40px",
  },
  modalHeaderTitle: {
    fontSize: "22px",
  },
  modalContent: {
    padding: "0 40px",
    [theme.breakpoints.down("xs")]: {
      padding: "0 20px",
    },
  },
  modalSectionTitle: {
    marginBottom: 10,
  },
  cardAction: {
    padding: 4,
    minWidth: "auto",
    fontSize: "inherit",
    marginRight: 10,
    marginTop: 10,
  },
  title: {
    marginTop: 10,
  },
  subscribe: {
    marginTop: 10,
  },
  subscribeWrapper: {
    textAlign: "right",
  },
  author: {
    marginBottom: 30,
    fontSize: 15,
    color: "#000",
    fontWeight: 500,
    display: "block",
  },
  authorAvatar: {
    width: 60,
    height: 60,
    borderRadius: 30,
    display: "inline-block",
    marginBottom: -24,
  },
  authorName: {
    display: "inline-block",
    marginLeft: 8,
  },
  games: {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  game: {
    display: "inline-block",
    marginRight: theme.spacing(0.5),
    marginTop: 10,
  },
  tags: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    marginBottom: 30,
  },
  tag: {
    display: "inline-block",
    marginRight: theme.spacing(0.5),
    marginTop: 10,
  },
  hash: {
    backgroundColor: "inherit",
    fontWeight: "bold",
  },
  videoWrapper: {
    marginTop: 20,
  },
  metaWrapper: {
    background: "rgba(26, 42, 54, 0.06)",
    padding: 16,
    marginTop: 20,
    marginBottom: 20,
  },
  divider: {
    marginBottom: 10,
  },
  description: {
    display: "flex",
    flexDirection: "column",
    marginTop: 10,
    whiteSpace: "pre-line",
  },
  relatedWrapper: {
    marginTop: 20,
  },
  followWrapper: {
    marginTop: 20,
  },
  socialShareWrapper: {
    margin: 10,
  },
  iconWrapper: {
    margin: 3,
  },
  videoImage: {
    maxWidth: "100%",
    [theme.breakpoints.up("lg")]: {
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  videoImageLink: {
    display: "block",
    marginTop: 20,
  },
  videoBannerAd: {
    marginTop: 10,
    display: "flex",
    justifyContent: "center",
  },
  videoBannerAdLink: {
    display: "block",
  },
  videoBannerAdImage: {
    maxWidth: "100%",
    width: "100%",
  },
  videoBannerLeftAd: {
    paddingTop: 20,
  },
}));

const Video = (props) => {
  const classes = useStyles();

  const { upload } = props;

  if (!upload) {
    return <Error statusCode={404} />;
  }

  const [selectedState, setSelectedState] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [likes, setLikes] = useState(upload.likes || 0);
  const [authorProfile, setAuthorProfile] = useState({});

  const [followingUser, setFollowingUser] = useState(null);

  let upNextQueue = getAllRelatedPosts(upload?.path);
  let upNextId = upNextQueue && upNextQueue[0].meta.id;

  useEffect(() => {
    if (props.auth.authenticated && props.auth.user) {
      isFollowingUser(props.auth.user.email, upload.author).then((res) => {
        return setFollowingUser(res);
      });
    }
    getUser(upload.author).then((doc) => setAuthorProfile(doc.data()));
  }, [upload.author]);

  useEffect(() => {
    setSelectedState();
  }, [modalOpen]);

  function toggleFollow() {
    setFollowingUser(!followingUser);
  }

  const large = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  const gridOpts = large ? { container: true, spacing: 3 } : {};
  const MGMZoneID = authorProfile?.MGMZoneID
    ? authorProfile?.MGMZoneID
    : "1696259";
  const BRLinkID = authorProfile?.BRLinkID
    ? authorProfile?.BRLinkID
    : "BTVTailLink";

  console.log("MGMZoneID", MGMZoneID);

  return (
    <>
      <Layout full={true}>
        <Container maxWidth="lg">
          <Grid {...gridOpts}>
            <Grid item lg={8}>
              <div className={classes.videoWrapper}>
                {upNextId && (
                  <VideoPlayer
                    src={upload.playbackUrl}
                    poster={upload.thumbnailUrl}
                    playbackSpeed
                    id={upload.id}
                    title={upload.title}
                    upNextId={upNextId}
                  />
                )}
              </div>

              <Grid container spacing={3}>
                <Grid item xs={6} md={7}>
                  <Typography
                    variant="h6"
                    component="h1"
                    className={classes.title}
                  >
                    {upload.title}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {`${upload.views} ${
                      upload.views === 1 ? `view` : `views`
                    } - ${moment(new Date(upload.created)).fromNow()}`}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={5} className={classes.subscribeWrapper}>
                  <Typography variant="caption" color="textSecondary">
                    <Button
                      className={classes.cardAction}
                      color="inherit"
                      size="small"
                      startIcon={<CommentIcon />}
                      onClick={() => {
                        document.getElementById("comment-feed-input").focus();
                        document
                          .getElementById("comment-feed-input")
                          .scrollIntoView();
                      }}
                    >
                      {upload.comments || 0}
                    </Button>
                    <Button
                      className={classes.cardAction}
                      color="inherit"
                      size="small"
                      startIcon={<LikeIcon />}
                      onClick={async () => {
                        if (!props.auth.authenticated) {
                          router.push({
                            pathname: "/register",
                            query: { like: upload.id },
                          });
                          return;
                        }

                        const result = await db
                          .doc(upload.path)
                          .collection("likes")
                          .where("user", "==", props.auth.user.email)
                          .get();

                        if (result.empty) {
                          await db.doc(upload.path).collection("likes").add({
                            user: props.auth.user.email,
                            userName: props.auth.userData.username,
                            created: new Date(),
                          });

                          await db.doc(upload.path).set(
                            {
                              meta: { likes: (upload.likes || 0) + 1 },
                            },
                            { merge: true }
                          );

                          setLikes(likes + 1);
                        }
                      }}
                    >
                      {likes}
                    </Button>
                  </Typography>

                  {props.auth.authenticated &&
                    upload.author != props.auth.user.email &&
                    followingUser && (
                      <Button
                        size="small"
                        variant="contained"
                        color="secondary"
                        className={classes.subscribe}
                        onClick={() => {
                          unfollowUser(props.auth.user.email, upload.author);
                          toggleFollow();
                        }}
                      >
                        Unsubscribe
                      </Button>
                    )}

                  {(!props.auth.authenticated ||
                    (upload.author != props.auth.user.email &&
                      !followingUser)) && (
                    <Button
                      size="small"
                      variant="contained"
                      className={classes.subscribe}
                      style={{ backgroundColor: "#E60019" }}
                      color="secondary"
                      onClick={() => {
                        if (props.auth.authenticated) {
                          followUser(props.auth.user.email, upload.author);
                          toggleFollow();
                        } else {
                          router.push({
                            pathname: "/register",
                            query: { subscribe: upload.authorName },
                          });
                        }
                      }}
                    >
                      Subscribe
                    </Button>
                  )}
                  <Button
                    size="small"
                    variant="contained"
                    className={classes.subscribe}
                    style={{ backgroundColor: "#E60019", marginLeft: 10 }}
                    color="secondary"
                    onClick={() => {
                      setModalOpen(true);
                      db.doc(upload.path).set(
                        {
                          meta: { tailBetViews: (upload.likes || 0) + 1 },
                        },
                        { merge: true }
                      );
                    }}
                  >
                    Tail this Bet
                  </Button>
                  <div className={classes.socialShareWrapper}>
                    <span className={classes.iconWrapper}>
                      <FacebookShareIcon />
                    </span>
                    <span className={classes.iconWrapper}>
                      <TwitterShareIcon />
                    </span>
                    <span className={classes.iconWrapper}>
                      <EmailShareIcon />
                    </span>
                  </div>
                </Grid>
              </Grid>
              {/* Banner add beneath video */}
              {/* <div className={classes.videoBannerAd}>
                <iframe
                  id="partners1677370"
                  name="partners1677370"
                  src="https://mediaserver.betmgmpartners.com/renderBanner.do?zoneId=1677370&t=f&v=1&securedDomain=y"
                  frameborder="0"
                  marginheight="0"
                  marginwidth="0"
                  scrolling="no"
                  width="728"
                  height="90"
                ></iframe>
              </div> */}

              <div className={classes.metaWrapper}>
                <Link
                  href={`/profile/${upload.authorName}`}
                  className={classes.author}
                >
                  <img
                    src={`/api/avatar/${upload.authorName}`}
                    className={classes.authorAvatar}
                  />
                  <span className={classes.authorName}>
                    {upload.authorName}
                  </span>
                </Link>

                <Divider className={classes.divider} />

                <Grid container spacing={3}>
                  {upload.games.length > 0 && (
                    <Grid item xs={12} md={5}>
                      <GameList wrapped gameIds={upload.games} />
                    </Grid>
                  )}
                  <Grid item xs={12} md={upload.games.length > 0 ? 7 : 12}>
                    <style>
                      {`.${classes.description} p {margin-top: 0; margin-bottom: 10px;}`}
                      {`.${classes.description} ul {margin-top: 0; margin-bottom: 10px; display: flex; flex-direction: column;}`}
                      {`.${classes.description} ul li {margin-top: 0;margin-bottom: 10px;}`}
                      {`.${classes.description} ol {margin-top: 0; margin-bottom: 10px; display: flex; flex-direction: column;}`}
                      {`.${classes.description} ol li {margin-top: 0;margin-bottom: 10px;}`}
                    </style>
                    <div
                      className={classes.description}
                      dangerouslySetInnerHTML={{ __html: upload.description }}
                    >
                      {/* {linkify(upload.description)} */}
                      {/* { upload.description } */}
                    </div>
                  </Grid>
                </Grid>
              </div>

              {upload.tags.length > 0 && (
                <TagList wrapped tagIds={upload.tags} />
              )}
              <CommentFeed upload={upload.path} />
            </Grid>
            <Grid item lg={4}>
              {/* Ad left next to video */}
              <div className={classes.videoBannerLeftAd}>
                {/* <iframe id="partners1678724" name="partners1678724"
            src="https://mediaserver.betmgmpartners.com/renderBanner.do?zoneId=1678724&t=f&v=1&securedDomain=y"
            frameborder="0" scrolling="no" marginwidth="0" marginheight="0" width="120" height="600">
            </iframe> */}
              </div>
              {/* <iframe
                id="partners1677372"
                name="partners1677372"
                src="https://mediaserver.betmgmpartners.com/renderBanner.do?zoneId=1677372&t=f&v=1&securedDomain=y"
                frameborder="0"
                marginheight="0"
                marginwidth="0"
                scrolling="no"
                width="250"
                height="250"
                style={{ marginTop: "20px" }}
              ></iframe> */}

              <div className={classes.relatedWrapper}>
                <VideoFeed
                  upload={upload.path}
                  title="Up Next"
                  columns={large ? 12 : 0}
                  variant="alt"
                />
              </div>
              {/* Ad at the bottom right of page */}
              {/* <iframe
                id="partners1677373"
                name="partners1677373"
                src="https://mediaserver.betmgmpartners.com/renderBanner.do?zoneId=1677373&t=f&v=1&securedDomain=y"
                frameborder="0"
                marginheight="0"
                marginwidth="0"
                scrolling="no"
                width="250"
                height="250"
              ></iframe> */}
              <div>
                {/* <iframe id="partners1678723" name="partners1678723"
          src="https://mediaserver.betmgmpartners.com/renderBanner.do?zoneId=1678723&t=f&v=1&securedDomain=y"
          frameborder="0" scrolling="no" marginwidth="0" marginheight="0" width="300" height="250">
          </iframe> */}
              </div>
            </Grid>
          </Grid>
          <Modal open={modalOpen} onClose={() => console.log("Close modal")}>
            <div className={classes.modal}>
              {/* Modal Header */}
              <div className={classes.modalHeader}>
                <Typography
                  component="h1"
                  variant="h5"
                  className={classes.modalHeaderTitle}
                >
                  Tail This Bet
                </Typography>

                <IconButton onClick={() => setModalOpen(false)}>
                  <CloseIcon />
                </IconButton>
              </div>

              {/* Modal Content */}
              <div className={classes.modalContent}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-simple-select-label">
                    Select Your State
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedState}
                    onChange={(event) => setSelectedState(event.target.value)}
                  >
                    {states.map((d) => (
                      <MenuItem value={d}>{d.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {selectedState && (selectedState.MGM || selectedState.BR) && (
                  <p>Click on the image below to place your bet!</p>
                )}

                {selectedState && !selectedState.MGM && !selectedState.BR && (
                  <p>
                    Either your state does not allow sports betting or we do not
                    have a sports book partners in your state. Please follow the
                    links below for more information:
                    <br />
                    <br />
                    <a href="https://betrivers.com/" target="_blank">
                      https://betrivers.com/
                    </a>
                    <br />
                    <a href="http://sports.betmgm.com/" target="_blank">
                      http://sports.betmgm.com/
                    </a>
                  </p>
                )}

                {selectedState && selectedState?.BR && modalOpen && (
                  <a
                    onClick={() => {
                      db.doc(upload.path).set(
                        {
                          meta: { tailBetClicks: (upload.likes || 0) + 1 },
                        },
                        { merge: true }
                      );
                    }}
                    href={selectedState.BR + BRLinkID}
                    target="_blank"
                    style={{
                      height: 250,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <iframe
                      frameborder="0"
                      scrolling="no"
                      width="250"
                      height="250"
                      style={{ pointerEvents: "none" }}
                      src="https://media.co.betrivers.com/I.ashx?btag=a_6437b_750c_&affid=1636&siteid=6437&adid=750&c="
                    ></iframe>
                  </a>
                )}
                <br />
                {selectedState?.MGM && (
                  <a
                    onClick={() => {
                      console.log(selectedState.MGM + MGMZoneID);
                      db.doc(upload.path).set(
                        {
                          meta: { tailBetClicks: (upload.likes || 0) + 1 },
                        },
                        { merge: true }
                      );
                    }}
                    href={selectedState.MGM + MGMZoneID}
                    target="_blank"
                    rel="nofollow"
                  >
                    <img
                      className="image"
                      height="250"
                      width="300"
                      alt="no image"
                      src="https://mediaserver.betmgmpartners.com/renderBanner.do?zoneId=1696259&t=i&v=1"
                    />
                  </a>
                )}
              </div>
            </div>
          </Modal>
        </Container>
      </Layout>
    </>
  );
};

export async function getServerSideProps(context) {
  const authResult = await db.collection("users").doc().get();
  console.log("authResult", authResult.data());

  const results = await db
    .collectionGroup("uploads")
    .where("meta.id", "==", context.params.video)
    .get();

  let upload = null;

  if (!results.empty) {
    const result = results.docs[0];

    const data = result.data();

    const gameIds = (data.meta.games || []).map((g) => g.id).splice(0, 10);
    const tagIds = (data.meta.tags || []).map((t) => t.id).splice(0, 10);

    upload = {
      path: result.ref.path,
      playbackUrl: data.playbackUrl,
      thumbnailUrl: data.meta.thumbnail,
      title: data.meta.title,
      description: data.meta.description,
      author: data.meta.author,
      authorName: data.meta.authorName,
      views: (data.meta.views || 0) + 1,
      comments: data.meta.comments || 0,
      likes: data.meta.likes || 0,
      created: data.meta.created.toMillis(),
      games: gameIds,
      tags: tagIds,
      id: context.params.video,
    };

    // record the view
    await result.ref.set(
      {
        meta: { views: (data.meta.views || 0) + 1 },
      },
      { merge: true }
    );
  }

  return {
    props: {
      upload: upload,
    },
  };
}

export default withAuth(Video);

const states = [
  { name: "Alabama" },
  { name: "Alaska" },
  { name: "Arizona" },
  { name: "Arkansas" },
  { name: "California" },
  {
    name: "Colorado",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
    BR: "https://media.co.betrivers.com/C.ashx?btag=a_6437b_750c_&affid=1636&siteid=6437&adid=750&c=",
  },
  { name: "Connecticut" },
  { name: "Delaware" },
  { name: "Florida" },
  { name: "Georgia" },
  { name: "Hawaii" },
  { name: "Idaho" },
  {
    name: "Illinois",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
    BR: "https://media.il.betrivers.com/C.ashx?btag=a_6437b_955c_&affid=1636&siteid=6437&adid=955&c=",
  },
  {
    name: "Indiana",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
    BR: "https://media.in.betrivers.com/C.ashx?btag=a_6437b_596c_&affid=1636&siteid=6437&adid=596&c=",
  },
  {
    name: "Iowa",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
    BR: "https://media.ia.betrivers.com/C.ashx?btag=a_6437b_1348c_&affid=1636&siteid=6437&adid=1348&c=",
  },
  {
    name: "Kansas",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
  },
  { name: "Kentucky" },
  {
    name: "Louisiana",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
    BR: "https://media.la.betrivers.com/C.ashx?btag=a_6437b_3685c_&affid=1636&siteid=6437&adid=3685&c=",
  },
  { name: "Maine" },
  {
    name: "Maryland",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
    BR: "https://media.md.betrivers.com/C.ashx?btag=a_6437b_3835c_&affid=1636&siteid=6437&adid=3835&c=",
  },
  { name: "Massachusetts" },
  { name: "Michigan" },
  { name: "Minnesota" },
  { name: "Mississippi" },
  { name: "Missouri" },
  { name: "Montana" },
  { name: "Nebraska" },
  { name: "Nevada" },
  { name: "New Hampshire" },
  { name: "New Jersey" },
  { name: "New Mexico" },
  {
    name: "New York",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
    BR: "https://media.ny.betrivers.com/C.ashx?btag=a_6437b_3599c_&affid=1636&siteid=6437&adid=3599&c=",
  },
  { name: "North Carolina" },
  { name: "North Dakota" },
  {
    name: "Ohio",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
    BR: "https://media.oh.betrivers.com/C.ashx?btag=a_6437b_3858c_&affid=1636&siteid=6437&adid=3858&c=",
  },
  { name: "Oklahoma" },
  {
    name: "Ontario",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
    BR: "https://media.on.betrivers.ca/C.ashx?btag=a_6437b_3741c_&affid=1636&siteid=6437&adid=3741&c=",
  },
  { name: "Oregon" },
  { name: "Pennsylvania" },
  { name: "Rhode Island" },
  { name: "South Carolina" },
  { name: "South Dakota" },
  {
    name: "Tennessee",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
  },
  { name: "Texas" },
  { name: "Utah" },
  { name: "Vermont" },
  { name: "Virginia" },
  { name: "Washington" },
  {
    name: "Washington DC",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
  },
  { name: "West Virginia" },
  { name: "Wisconsin" },
  {
    name: "Wyoming",
    MGM: "https://promo.nj.betmgm.com/en/promo/geolocator?orh=promo.betmgm.com&wm=7102720&zoneId=",
  },
];
